import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/Logo_Sozialministerium_2026.svg")